import { Chip } from '@mui/material';

type Props = {
  title: string;
  onDelete: () => void;
  disabled?: boolean;
};

export const SelectedFilterPill = ({ title, onDelete, disabled }: Props) => (
  <Chip label={title} onDelete={disabled ? undefined : onDelete} />
);
